import amsterdam from "public/dataCenters/amsterdam.jpg";
import berlin from "public/dataCenters/berlin.jpg";
import kolkata from "public/dataCenters/kolkata.jpg";
import mumbai from "public/dataCenters/mumbai.jpg";
import vancouver from "public/dataCenters/vancouver.jpg";
import melbourne from "public/dataCenters/melbourne.jpg";

export const DATA_CENTER_CONSTANTS = {
  ACTIVE_SERVICE_LOCATION: "Active Service Locations",
  DATA_CENTER: "Our Data Centers",
  DATA_CENTER_DESC: "We have a range of high-performance data centers.",
  DATA_CENTER_LOCATIONS: "Our Datacenter Locations",
  PlANNED_SERVICE_LOCATIONS: "Planned Service Locations",
};

export const PLANNED_SERVICE_LOCATIONS = [
  { id: 1, name: "Mumbai", image: mumbai },
  { id: 2, name: "Kolkata", image: kolkata },
  { id: 3, name: "Amsterdam", image: amsterdam },
  { id: 4, name: "Melbourne", image: melbourne },
  { id: 5, name: "Berlin", image: berlin },
  { id: 6, name: "Vancouver", image: vancouver },
];

export const DATA_CENTER_LOCATION_LIST = [
  { name: "Cologix - Columbus, OH", address: "585+Scherers+Ct,+Columbus,+OH+43085,+USA" },
  {
    name: "Montreal, Canada ",
    address: "2341+ALFRED+NOBEL+BLVD%0D%0ASAINT-LAURENT+QC+H4S+2A9+CA",
  },
  {
    name: "New Jersey, USA ",
    address: "9+Wing+Dr,+Cedar+Knolls,+NJ+07927,+USA",
  },
  { name: "Dallas, TX ", address: "1950+N+Stemmons+Fwy,+Dallas,+TX+75207,+USA" },

  {
    name: "San Francisco",
    address: "48233+Warm+Springs+Blvd,+Fremont,+CA+94539,+USA",
  },
  {
    name: "Dublin ,California",
    address: "11501+Dublin+Blvd,+Dublin,+CA+94568,+USA",
  },
  {
    name: "New Delhi , India",
    address: "First+Floor+It-02,+CP-05,+Sector+8,+Imt+Manesar,+Gurugram,+Haryana+122051",
  },
  {
    name: "Bangalore, India | Gateway to APAC ",
    address:
      "Plot+111+%26+112,+Export+Promotion+Industrial+Park+5,+Bharti+Airtel+Limited,+Rd+Number+7,+Vijayanagar,+EPIP+Zone,+Whitefield,+Bengaluru,+Karnataka+560066",
  },
  {
    name: "London, UK ",
    address: "London,+United+Kingdom",
  },
];
